var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81525 8.10225L9 5.9175L11.1859 8.10337L12.4571 6.83212L9 3.375L5.544 6.831L6.81525 8.10225ZM3.375 9L4.64625 7.72875L5.9175 9L4.64625 10.2713L3.375 9ZM6.81525 9.89775L9 12.0825L11.1859 9.89663L12.4571 11.1673L9 14.625L5.544 11.169L5.54231 11.1673L6.81525 9.89775ZM12.0825 9L13.3538 7.72875L14.625 9L13.3538 10.2713L12.0825 9ZM10.2892 8.99888H10.2904V9L9 10.2904L7.71131 9.00225L7.70906 9L7.71131 8.99831L7.93687 8.77219L8.04656 8.6625L9 7.70963L10.2898 8.99944L10.2892 8.99888Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.b9e4d543fe580664f53608a4943ee26e.svg";
export { ForwardRef as ReactComponent };